import React from "react";
import useStyles from "./styles";
import { Drawer, Grid, Container } from "@material-ui/core";

const DialogBottom = props => {
	const classes = useStyles();
	const { open, handleClose, children, isShowKeyboard = false } = props;
	return (
		<Drawer
			anchor={"bottom"}
			open={open}
			onClose={handleClose}
			classes={{ root: classes.rootPage }}
		>
			<Grid classes={{ root: classes.header }} />
			<Container
				maxWidth="xs"
				classes={{ root: classes.root }}
				style={{
					height: isShowKeyboard ? "100vh" : "auto",
					maxHeight: !isShowKeyboard ? 550 : "100vh"
				}}
			>
				{children}
			</Container>
		</Drawer>
	);
};

export default DialogBottom;
